import React, {useEffect, useState}from 'react';
import { Typography, Container, Box, Paper, useTheme, Zoom, Fab, Link } from '@mui/material';
import { useMediaQuery } from "react-responsive";
import { KeyboardArrowUpOutlined } from '@mui/icons-material';
import { abrirPreferencias } from '../domain/consentimiento/consentimiento';

const TermsAndConditions = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' 
    });
    
    const handleScroll = () => {
      // boton para volver a top si se scrollea completo
      setShowScrollTop(window.scrollY > 300);
    };
    
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <Box
        sx={{
          background: '#0b0062',
          py: !isMobile ? 12 : 4,
          mb: 4,
          color: 'white',
          textAlign: 'center'
        }}
      >
        <Container maxWidth="lg">
          <Typography
            sx={{ fontSize: !isMobile ? "38px" : "24px", }}
            fontWeight="bold">
            Términos y Condiciones de Uso - PassGo
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mb: 6 }}>
        <Paper
          elevation={2}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 2,
            backgroundColor: '#ffffff'
          }}
        >
          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              1. ROL DE PASSGO
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                PassGo es una plataforma digital que facilita la compra de entradas para eventos organizados por terceros (en adelante, “Organizadores”). Actúa únicamente como intermediario tecnológico entre el comprador (en adelante, “Usuario”) y el Organizador. <br />
                PassGo no es organizador, coorganizador, productor, promotor ni responsable legal de los eventos publicados. En consecuencia, no asume ninguna responsabilidad respecto de la organización, calidad, realización, postergación, suspensión, reprogramación o cancelación de los mismos.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              2. RESPONSABILIDAD DEL ORGANIZADOR
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                El Organizador es el único y exclusivo responsable de la realización del evento, la calidad del servicio ofrecido y el cumplimiento de toda la normativa vigente. <br />
                Al adquirir una entrada, el Usuario acepta expresamente las condiciones impuestas por el Organizador, incluyendo sus políticas de cambios, devoluciones, accesibilidad, programación, admisión y demás aspectos inherentes al evento.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              3. CONDICIONES DE LA COMPRA
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                Antes de finalizar la compra, el Usuario deberá verificar cuidadosamente todos los datos del evento: nombre, fecha, ubicación, horario, ubicación de las entradas, sector y/o asiento. <br />
                Las compras son definitivas. No se permiten cambios, devoluciones ni reintegros por error en la selección o por inasistencia del Usuario. La compra se considera válida únicamente una vez aprobado el pago por la entidad correspondiente.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              4. CANCELACIONES, SUSPENSIONES O MODIFICACIONES
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                En caso de cancelación del evento, el Organizador dispone de hasta 90 días para efectuar la devolución del importe abonado. <br />
                PassGo no realiza reembolsos directamente, salvo que el Organizador lo autorice formalmente y deposite previamente los fondos necesarios. <br />
                El Organizador se reserva el derecho de modificar fechas, horarios, locación, programación, artistas o condiciones generales del evento sin previo aviso. También podrá ejercer el derecho de admisión conforme la normativa vigente.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              5. VALIDACIÓN DE ENTRADAS
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                Las entradas son válidas únicamente si fueron adquiridas a través de la Plataforma PassGo. Cada entrada cuenta con un código QR único, que será escaneado al ingreso del evento. <br />
                El Usuario deberá presentar su entrada en formato digital o impreso, junto con su DNI. <br />
                PassGo no se responsabiliza por el ingreso en caso de pérdida, deterioro, robo, falsificación o problemas técnicos del dispositivo del Usuario.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              6. ACCESO AL EVENTO
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                El ingreso puede estar sujeto a controles de seguridad. El personal del evento podrá solicitar inspección de pertenencias y negar el acceso en caso de incumplimiento de las normas del Organizador. <br />
                El ingreso con cámaras, grabadoras, alimentos o elementos prohibidos queda a criterio exclusivo del Organizador.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              7. MEDIOS DE PAGO Y CONFIRMACIÓN
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                La compra se considera confirmada únicamente cuando el pago ha sido aprobado por el sistema correspondiente. <br />
                En caso de rechazo por parte de la entidad emisora de la tarjeta o billetera virtual, la operación será anulada sin cargo alguno.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              8. CARGOS POR SERVICIO
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                Toda entrada adquirida a través de PassGo podrá incluir un cargo por servicio, claramente indicado al momento de la compra. <br />
                Este cargo corresponde a los costos operativos y tecnológicos de la Plataforma y no es reembolsable bajo ninguna circunstancia.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              9. EVENTOS GRATUITOS
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                Los eventos gratuitos también están sujetos a disponibilidad de cupo y confirmación de inscripción. Las entradas son personales e intransferibles. <br />
                La emisión no garantiza ingreso si no se cumplen los requisitos exigidos por el Organizador (puntualidad, DNI, código válido, etc.). <br />
                Está prohibida la reventa o comercialización de entradas gratuitas. <br />
                PassGo y el Organizador se reservan el derecho de modificar o cancelar este tipo de eventos sin obligación de compensación alguna.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              10. USO DE IMAGEN Y REGISTRO DEL EVENTO
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                Al asistir a un evento, el Usuario autoriza al Organizador a registrar imágenes, videos o transmisiones en vivo, que podrán ser utilizados con fines promocionales, informativos o comerciales. <br />
                El Usuario acepta que su imagen pueda aparecer en dichos registros sin que ello genere derecho a indemnización ni compensación alguna.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              11. USO DE LA PLATAFORMA Y CONDUCTA DEL USUARIO
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                El Usuario se compromete a utilizar la Plataforma de manera lícita y conforme a estos Términos. Está prohibido:
              </Typography>
              <Box sx={{ ml: 3, mb: 2 }}>
                <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: '#5656ff',
                      mr: 2
                    }}
                  />
                  Crear múltiples cuentas con datos falsos o suplantar identidades.
                </Typography>
                <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: '#5656ff',
                      mr: 2
                    }}
                  />
                  Revender entradas o utilizar bots para comprar automáticamente.
                </Typography>
                <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: '#5656ff',
                      mr: 2
                    }}
                  />
                  Alterar, vulnerar o manipular el sistema.
                </Typography>
              </Box>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                PassGo podrá suspender o eliminar cuentas sin previo aviso ante cualquier uso indebido o sospechoso.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              12. PROTECCIÓN DE DATOS PERSONALES Y COOKIES
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                <strong>12.1. Datos personales.</strong> PassGo garantiza el tratamiento responsable y seguro de los datos personales, conforme la Ley 25.326. Los datos podrán ser utilizados para brindar el servicio, prevenir fraudes, y realizar comunicaciones informativas o promocionales.
              </Typography>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                El Usuario podrá ejercer los derechos de acceso, rectificación, supresión o actualización enviando un correo a: soporte@passgo.com.ar. La Dirección Nacional de Protección de Datos Personales es el organismo responsable en caso de reclamos por incumplimientos.
              </Typography>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                <strong>12.2. Cookies.</strong> La Plataforma utiliza cookies esenciales, necesarias para iniciar sesión, comprar y que el sitio funcione, que no pueden desactivarse. Con el consentimiento del Usuario, también puede utilizar cookies de publicidad, que permiten a los Organizadores medir sus anuncios, y cookies de analítica, para obtener estadísticas de uso y mejorar la Plataforma. El Usuario puede aceptar o rechazar estas categorías al ingresar y modificar su elección en cualquier momento desde{" "}
                <Link
                  component="button"
                  type="button"
                  underline="always"
                  onClick={abrirPreferencias}
                  sx={{ color: '#5656ff', font: 'inherit', fontWeight: 600, verticalAlign: 'baseline' }}
                >
                  Configurar cookies
                </Link>
                , en el pie de página.
              </Typography>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                <strong>12.3. Medición publicitaria por cuenta del Organizador.</strong> El Organizador de un evento puede configurar en la Plataforma herramientas de medición de Meta Platforms, Inc. para su evento:
              </Typography>
              <Box sx={{ ml: 3, mb: 2 }}>
                <Typography sx={{ display: 'flex', alignItems: 'baseline', mb: 1, lineHeight: 1.7 }}>
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      flexShrink: 0,
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: '#5656ff',
                      mr: 2,
                      transform: 'translateY(-2px)'
                    }}
                  />
                  <span>
                    <strong>Meta Pixel:</strong> se carga únicamente en las páginas de ese evento y solo si el Usuario aceptó las cookies de publicidad. Informa a Meta las visitas a la página del evento, el inicio de la compra y la compra realizada, con su importe y moneda.
                  </span>
                </Typography>
                <Typography sx={{ display: 'flex', alignItems: 'baseline', mb: 1, lineHeight: 1.7 }}>
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-block',
                      flexShrink: 0,
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: '#5656ff',
                      mr: 2,
                      transform: 'translateY(-2px)'
                    }}
                  />
                  <span>
                    <strong>Conversions API:</strong> al aprobarse una compra en ese evento, PassGo informa a Meta la compra (importe, moneda y cantidad de entradas) junto con el correo electrónico, teléfono, nombre y apellido del Usuario cifrados por hash (SHA-256), un identificador interno también cifrado, la dirección IP, los datos del navegador y, si existen, los identificadores de las cookies de Meta. PassGo nunca envía el correo ni el teléfono sin cifrar.
                  </span>
                </Typography>
              </Box>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                Estos datos se utilizan para que el Organizador mida y optimice su publicidad. Su tratamiento por parte de Meta se rige por las políticas de Meta Platforms, Inc., y el Organizador es responsable del uso que haga de esa información.
              </Typography>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                <strong>12.4. Origen de la compra.</strong> La Plataforma registra el enlace, el código o el anuncio desde el que el Usuario llegó a un evento (parámetros "ref" y "UTM" del enlace y código ingresado al comprar) y lo asocia a la compra, para brindar al Organizador reportes de ventas por canal y por campaña. Estos reportes no incluyen datos personales del Usuario.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              13. LIMITACIÓN DE RESPONSABILIDAD
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                El Usuario reconoce y acepta que utiliza la Plataforma bajo su exclusiva responsabilidad. <br />
                PassGo no garantiza la calidad ni ejecución de los eventos, ni será responsable por daños directos o indirectos, pérdidas económicas, inconvenientes operativos o situaciones imprevistas que ocurran antes, durante o después del evento. <br />
                PassGo no es responsable por decisiones del Organizador, problemas climáticos, técnicos, de seguridad, acceso o cambios de último momento.<br />
                La responsabilidad legal, fiscal y organizativa recae exclusivamente en el Organizador del evento.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              14. MODIFICACIONES
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                PassGo se reserva el derecho de modificar los presentes Términos y Condiciones en cualquier momento. Las modificaciones entrarán en vigencia a partir de su publicación en la Plataforma.<br />
                El uso continuado de la Plataforma implica la aceptación tácita de los términos actualizados.
              </Typography>
            </Box>
          </Box>

          <Box mb={5}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: '#0b0062',
                pb: 1,
                borderBottom: `2px solid ${theme.palette.grey[200]}`
              }}
            >
              15. JURISDICCIÓN Y LEY APLICABLE
            </Typography>
            <Box mt={2}>
              <Typography paragraph sx={{ lineHeight: 1.7 }}>
                Estos Términos y Condiciones se rigen por las leyes de la República Argentina. <br />
                Cualquier disputa será resuelta por los Tribunales Ordinarios de la Ciudad Autónoma de Buenos Aires, renunciando a cualquier otro fuero o jurisdicción.
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography sx={{ textAlign: "right", color: "#B5BABF" }}>Última actualización: Octubre, 2026.</Typography>
          </Box>
        </Paper>
      </Container>
      <Zoom in={showScrollTop}>
        <Fab 
          color="primary" 
          size="medium"
          aria-label="scroll back to top"
          onClick={scrollToTop}
          sx={{ 
            position: 'fixed', 
            bottom: 30, 
            right: 30,
            backgroundColor: "#0b0062",
            "&:hover": {
              backgroundColor: "#5656ff"
            }
          }}
        >
          <KeyboardArrowUpOutlined />
        </Fab>
      </Zoom>
    </>
  );
};

export default TermsAndConditions;